
  

  import { useRouter } from "next/router";
  import { useState, useEffect } from "react";
  
  import ReactPlaceholder from 'react-placeholder';
  import "react-placeholder/lib/reactPlaceholder.css";
  
  const Work = () => {
    const router = useRouter();
    const [pageName, setPageName] = useState("");
   
        
  
    const [ready, setReady] = useState(false);
    useEffect(()=>{
      setTimeout(() => {
        setReady(true)
      }, 1000);
    },[])
    return (
      <div className="section-gap healthcare-main" >
          <div className="container">
            <div className="main-work">
              <div className="section-title text-start">
                <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: "40px" }} >
                  <h2 className="work-heading">
                    It's like Uber, for {pageName} Testing.{" "}
                  </h2>
                </ReactPlaceholder>
              </div>
              <div className="row">
                <div className="col-lg-4 col-md-6 col-12">
                  <div className="work-card">
                    <ReactPlaceholder showLoadingAnimation ready={ready} style={{ width: "150px", height: "150px", paddingBottom: "20px" }} type="round">
                      <div className="work-card-img">
                        <img
                          src="/1new.gif"
                          className="card-img-top get-location-icon"
                          alt="above-fold-image"
                        />
                      </div>
                    </ReactPlaceholder>
                    <div className="work-card-description">
                      <h5 className="card-title work-title">
                        <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ width: "50%", marginTop: "20px" }}>
                          1.&nbsp;Get Tested
                        </ReactPlaceholder>
                      </h5>
                      <ReactPlaceholder showLoadingAnimation ready={ready} rows={3}>
                        <p className="card-text work-text text-light-blue">
                          At home testing or same day visits available at 5,000
                          partner locations.
                        </p>
                      </ReactPlaceholder>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-12">
                  <div className="work-card">
                    <ReactPlaceholder showLoadingAnimation ready={ready} style={{ width: "150px", height: "150px", paddingBottom: "20px" }} type="round">
                      <div className="work-card-img">
                        <img
                          src="/3smoothnew.gif"
                          className="card-img-top"
                          alt="above-fold-image"
                        />
                      </div>
                    </ReactPlaceholder>
                    <div className="work-card-description">
                      <h5 className="card-title work-title">
                        <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ width: "50%", marginTop: "20px" }}>
                          2.&nbsp;Get Results
                        </ReactPlaceholder>
                      </h5>
                      <ReactPlaceholder showLoadingAnimation ready={ready} rows={3}>
                        <p className="card-text work-text text-light-blue">
                          Most available in 12-48 hours from testing in your portal.
                        </p>
                      </ReactPlaceholder>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-12">
                  <div className="work-card">
                    <ReactPlaceholder showLoadingAnimation ready={ready} style={{ width: "150px", height: "150px", paddingBottom: "20px" }} type="round">
                      <div className="work-card-img">
                        <img
                          src="/2smoothNEW2.gif"
                          className="card-img-top"
                          alt="above-fold-image"
                        />
                      </div>
                    </ReactPlaceholder>
                    <div className="work-card-description">
                      <h5 className="card-title work-title">
                        <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ width: "50%", marginTop: "20px" }}>
                          3.&nbsp; Get Treatment
                        </ReactPlaceholder>
                      </h5>
                        <ReactPlaceholder showLoadingAnimation ready={ready} rows={3}>
                          <p className="card-text work-text text-light-blue">
                            Next Medical affiliated physicians will discuss
                            symptoms, review results, prescribe and oversee your
                            treatment plan if positive.
                          </p>
                        </ReactPlaceholder>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    );
  };
  export default Work;